<div class="root" [ngClass]="{ 'root_light': iamState(), 'root_login': isLoginPage()}">
  <app-error-notification></app-error-notification>
  <header *ngIf="!isLoading">
    <app-header></app-header>
  </header>
  <div [hidden]="isLoading" ui-view class="root__content"></div>
  <app-loader *ngIf="isLoading" class="centered centered_absolute"></app-loader>
  <app-dialog-confirm></app-dialog-confirm>
</div>
